import {
  Box,
  FormControl,
  //   FormHelperText,
  FormLabel,
  IconButton,
  InputAdornment,
  TextField,
  TextFieldProps,
} from '@mui/material';
import EyeIcon from 'icons/eye';
import EyeSlashIcon from 'icons/eyeSlash';
import React, { useState } from 'react';
import {
  Controller,
  UseControllerProps,
  useFormContext,
} from 'react-hook-form';

type OutlinedPasswordTextFieldProps = UseControllerProps & {
  textFieldProps: TextFieldProps;
  formLabel: string;
};

export default function OutlinedPasswordTextField({
  name,
  rules,
  textFieldProps,
  formLabel,
}: OutlinedPasswordTextFieldProps) {
  const [state, setState] = useState({
    password: '',
    showPassword: false,
  });

  const handleClickShowPassword = () => {
    setState({
      ...state,
      showPassword: !state.showPassword,
    });
  };

  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field }) => (
        <FormControl
          variant="outlined"
          error={textFieldProps.error}
          sx={{ width: 1 }}
        >
          <Box
            sx={{
              display: 'flex',
              textAlign: 'start',
              flexDirection: 'column',
              gap: 1.5,
              width: 1,
            }}
          >
            <FormLabel
              htmlFor={textFieldProps.id}
              sx={{ fontSize: 12, pl: 1.5 }}
            >
              {formLabel}
            </FormLabel>

            <TextField
              {...field}
              {...textFieldProps}
              variant="outlined"
              onChange={(e) => {
                field.onChange(e);
                if (textFieldProps.onChange) {
                  textFieldProps?.onChange(e);
                }
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowPassword}
                      onMouseDown={(e: React.MouseEvent) => {
                        e.preventDefault();
                      }}
                    >
                      {state.showPassword ? <EyeIcon /> : <EyeSlashIcon />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              id={textFieldProps.id}
              type={state.showPassword ? 'text' : 'password'}
              sx={{
                ...textFieldProps.sx,
                '& .MuiInputBase-root': { borderRadius: 4 },
                '& .MuiOutlinedInput-notchedOutline': { borderRadius: 4 },
              }}
            />
          </Box>
          {/* <FormHelperText>{textFieldProps.helperText}</FormHelperText> */}
        </FormControl>
      )}
    />
  );
}
